export enum LayoutTypes {
  Calculator = 'calculator',
  History = 'history'
}
